import { SurveyConfig, Trigger, Scope, Device } from "../configuration";

export type TriggerContext = {
    path: string
}

export abstract class TriggerResolver {
    protected surveys: SurveyConfig[];

    constructor(surveys: SurveyConfig[]) {
        this.surveys = surveys;
    }
    
    protected abstract resolveByTrigger(trigger: Trigger, context?: TriggerContext): SurveyConfig[];

    resolve(trigger: Trigger, context: TriggerContext): SurveyConfig | undefined {
        const survey = this.resolveByPriority(
            this.resolveByTrigger(trigger, context)
        );
        return survey;
    }
    setShown(survey: SurveyConfig) {
        switch (survey.scope) {
            case Scope.SESSION:
                sessionStorage.setItem(`survey-${survey.name}`, 'shown');
                break;
            case Scope.LIFE:
                localStorage.setItem(`survey-${survey.name}`, 'shown');
                break;
        }
    }
    hasBeenShown(survey: SurveyConfig): boolean {
        switch (survey.scope) {
            case Scope.SESSION:
                return sessionStorage.getItem(`survey-${survey.name}`) === 'shown';
            case Scope.LIFE:
                return localStorage.getItem(`survey-${survey.name}`) === 'shown';
            default:
                return false;
        }
    } 
    protected resolveByPriority(surveys: SurveyConfig[]): SurveyConfig | undefined {
        const sortedSurveys = surveys.sort((a, b) => (b.priority || 0) - (a.priority || 0))
        return sortedSurveys[0];
    }
    protected resolveDevice(survey: SurveyConfig): boolean {
        const isMobile = () => /Mobi|Android/i.test(navigator.userAgent);
        switch (survey.device) {
            case Device.MOBILE:
                return isMobile();
            case Device.DESKTOP:
                return !isMobile();
            default:
                return true;
        }
    }
}

export class DefaultTriggerResolver extends TriggerResolver {
    resolveByTrigger(trigger: Trigger, context: TriggerContext): SurveyConfig[] {
        const eligibleSurveys = this.surveys.filter(survey =>
            survey.trigger === trigger
            && (!survey.path || new RegExp(survey.path).test(context.path))
            && (!survey.scope || !this.hasBeenShown(survey))
            && this.resolveDevice(survey)
        );
        switch (trigger) {
            case Trigger.LOCATION:
            case Trigger.BUTTON:
            case Trigger.MOUSEOUT:
                return eligibleSurveys;
            default: 
                throw new Error(`Survey trigger not supported: ${trigger}`);
        }
    }
}